export default "__VITE_ASSET__BGQ9wB58__"